window.pre_order_status = true;
document.addEventListener('DOMContentLoaded', () => {
  window.subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    // console.log("variant change",event)
    const variant = event.data?.variant;
    const sectionId = event.data?.sectionId;
    if(variant && variant.available == true){
      const $pd_url = "https://preorders-api.elitesupps.com.au/get_availability?variant_id="+variant.id;
      fetch($pd_url).then(res => res.json()).then(response => {
        if(response.code == 4){
          $(".product__availability").html("Availability online: <span class='in__stock'>PRE ORDER</span>");
          $(".preorder-delivery-info").html(response.data.delivery_date);
           $(`#product-form-${sectionId}`).append(`<input type='hidden' class="preorder-properties" name='properties[Pre order]' value="${response.data.delivery_date}">`);
           $(`#product-form-${sectionId}`).append(`<input type='hidden' class="preorder-properties" name='properties[_is_preorder]' value="yes">`);
           $(`#product-form-${sectionId}`).append(`<input type='hidden' class="preorder-properties" name='properties[_waitlist_id]' value="${response.data.waitlist_id}">`);
           $('.expected-delivery').hide();
          const productForm = document.getElementById(`ProductSubmitButton-${sectionId}`);
          if (!productForm) return;
          const addButton = productForm.querySelector('[name="add"]');
          const addButtonText = productForm.querySelector('[name="add"] > span');
          // if(addButton.hasAttribute('disabled')) addButton.removeAttribute('disabled');
          addButtonText.textContent = "PRE-ORDER";
          $("[data-sis-widget-description]").addClass("hidden");
         } else{
          $("[data-sis-widget-description]").removeClass("hidden");
           $(".preorder-delivery-info").empty();
           $(".preorder-properties").remove();
           $('.expected-delivery').show();
         }
      });
    }
  });
  if(window.check_pre_order_item == true){
    fetch('/cart.js').then(res => res.json()).then(async (cart) => {
      const calls = cart.items.map(async (item) => {
        const pd_url = `https://preorders-api.elitesupps.com.au/get_availability?variant_id=${item.variant_id}`;
        const res = await fetch(pd_url);
        const response = await res.json();
        if (response.code != 4 && item.properties && item.properties['_is_preorder'] == "yes") {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: {"_":""}
            })
          });
        }
        if (response.code == 4 && (!item.properties || !item.properties['_is_preorder'])) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: {
                'Pre order': response.data.delivery_date,
                '_is_preorder': 'yes',
                '_waitlist_id': response.data.waitlist_id
              }
            })
          });
        }
      });
      await Promise.all(calls);
      fetch("/?section_id=cart-drawer", { credentials: "same-origin", method: "GET" }).then((function(data) {
        data.text().then((function(data) {
          console.log(data);
          document.getElementById("CartDrawer-CartItems").innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector("#CartDrawer-CartItems").innerHTML;
        }));
      }));
    });
  }

  if (window.pre_order_list && window.pre_order_list.includes(parseInt(window.selected_variant))) {
    const variantSelects = document.querySelector('variant-radios');
    const variantInput = variantSelects?.querySelector('input[type="radio"]');
    if (variantInput) {
      variantInput.dispatchEvent( 
        new Event('change', { bubbles: true })
      );
    }
  }
}); 